import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingAiNeonFilterConfig } from '@/data/landingConfig/landingAiNeonFilterConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_AiNeonFilter } from './schemaObject';

interface Props {}
const AiNeonFilter: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_AiNeonFilter} />
			<LandingTemplate
				data={landingAiNeonFilterConfig}
				funnelLinkService={GenerateLandingLinkService.funnelCartoonGenerator()}
			/>
		</>
	);
};

export default AiNeonFilter;
